import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

export default function HighchartsLineChart({ labels = [], data = [], height = 260 }) {
  const options = {
    chart: {
      type: 'areaspline',
      height,
      backgroundColor: 'transparent',
    },
    title: { text: null },
    xAxis: {
      categories: labels,
      labels: { style: { color: '#374151', fontWeight: 700 } },
      tickLength: 0,
    },
    yAxis: {
      title: { text: null },
      labels: { style: { color: '#374151' } },
      gridLineColor: '#eef2ff',
    },
    tooltip: { shared: true, valueSuffix: '' },
    series: [
      {
        name: 'Artworks',
        data,
        color: '#4338ca',
        fillColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, 'rgba(67,56,202,0.16)'],
            [1, 'rgba(67,56,202,0)']
          ]
        },
        marker: { enabled: true, radius: 4, fillColor: '#ffffff', lineWidth: 2, lineColor: '#4338ca' },
        dataLabels: {
          enabled: true,
          format: '{y}',
          style: { fontWeight: '700', color: '#0f172a' },
          verticalAlign: 'bottom',
          y: -6
        }
      }
    ],
    credits: { enabled: false },
    legend: { enabled: false },
    responsive: {
      rules: [
        {
          condition: { maxWidth: 600 },
          chartOptions: { xAxis: { labels: { rotation: -45 } } }
        }
      ]
    }
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
}
